import React from 'react'
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
// import CheckCircle from '@material-ui/icons/CheckCircle';
// import Sync from '@material-ui/icons/Sync';
import PropTypes from 'prop-types';
import { IconSync, IconCheckCircle } from '../Icons';

const styles = theme => ({
    btn: {
        marginLeft: 'auto',
        paddingLeft: '10px',
        float: 'right',
        '&:disabled': {
            background: theme.palette.primary.light,
            color: '#eee'
        }
    },
    '@keyframes spin': {
        '0%': { transform: 'rotate(180deg)' },
        '100%': { transform: 'rotate(0deg)' }
    },
    spinner: {
        fontSize: 20,
        marginRight: 4,
        animation: 'spin 1s infinite linear',
        transformOrigin: 'center',
    },
    smallicon: {
        marginRight: 4
    }
})

/**
 * 
 * @param {processing} param0 something
 */
const ButtonSubmit = ({ processing, formFilled, label, classes, submitFn }) => (
    <Button
        type="submit"
        variant="contained"
        color="primary"
        className={classes.btn}
        disabled={!formFilled || processing}
        onClick={submitFn}
    >
        {
            processing
                ? <IconSync cssclass={classes.spinner} />
                : <IconCheckCircle style={{fontSize: 16,marginRight: 4 }} />
        }
        {label}
    </Button>
)

ButtonSubmit.propTypes = {
    label: PropTypes.string.isRequired
}

export default withStyles(styles)(ButtonSubmit);